import React from "react";

/* img imports */
import backArrowIcon from "../assets/images/back-arrow.png";

const BackArrow = ({ handleRedirect, linkName }) => {
  return (
    <div className="back-arrow-icon" onClick={() => handleRedirect(linkName)}>
      <img src={backArrowIcon} alt="Back Arrow Icon" />
    </div>
  );
};

export default BackArrow;
